import { CircularProgress, Stack } from "@mui/material"
import { useStore } from "@nanostores/react"
import React from "react"

import { TradingViewChart } from "../../components/TradingViewChart"

import { usePool } from "@/context/PoolContext"

import { useTokenInfo } from "@/hooks/use-token-info"
import { $usdCurrency } from "@/stores/currency-store"

import { useDataFeed } from "@/utils/tradingview-utils"

export function PriceCandlesChartBase() {
  const { baseToken, quoteToken, isReversed, isFlipped, pool } = usePool()

  const [baseTokenInfo] = useTokenInfo(baseToken)
  const [quoteTokenInfo] = useTokenInfo(quoteToken)

  const useCurrency = useStore($usdCurrency)

  let bt = baseTokenInfo
  let qt = quoteTokenInfo

  if (isFlipped) {
    bt = quoteTokenInfo
    qt = baseTokenInfo

    if (isReversed) {
      bt = baseTokenInfo
      qt = quoteTokenInfo
    }
  } else {
    if (isReversed) {
      bt = quoteTokenInfo
      qt = baseTokenInfo
    }
  }

  const df = useDataFeed(pool, bt, qt, useCurrency, isReversed)

  if (!baseTokenInfo || !quoteTokenInfo)
    return (
      <Stack justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
        <CircularProgress />
      </Stack>
    )

  const symbol = baseTokenInfo.ticker

  if (!df) return null

  return <TradingViewChart symbol={symbol} df={df} />
}

export const PriceCandlesChart = React.memo(PriceCandlesChartBase)
